import {
  dateFormat,
  formatDate,
} from "../../../../services/Utils/functionService";
import { usePartnerWorkingFolderStore } from "../../../../stores/Cac/Partner/partnerWorkingFolder";
import trash from "../../../../assets/icons/trash.svg";
import send from "../../../../assets/icons/send.svg";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  revokeAccessWorkingFolder,
  sendNewAccessWorkingFolder,
  userAssignToWorkingFolder,
  userUnassignToWorkingFolder,
} from "../../../../services/Api/customerService";
import {
  showToastError,
  showToastSuccess,
} from "../../../../services/Toasts/toasts";

const UsersAffectedWorkingFolder = () => {
  const { t } = useTranslation();
  const {
    workingFolderDetails,
    updateWorkingFolder,
    setUpdateWorkingFolder,
    collabsAssignedToClient,
    checkboxValuesCollabs,
  } = usePartnerWorkingFolderStore();
  const { idCustomer, idWorkingFolder } = useParams();

  const handleRevokeAccess = (email: string) => {
    const data = {
      email: email,
    };
    revokeAccessWorkingFolder(Number(idCustomer), Number(idWorkingFolder), data)
      .then(() => {
        setUpdateWorkingFolder(!updateWorkingFolder);
        showToastSuccess("L'accès a été révoqué avec succès");
      })
      .catch(() => {
        showToastError("Une erreur s'est produite. Veuillez réessayer.");
      });
  };

  const handleSendAccess = (email: string) => {
    const data = {
      email: email,
    };
    sendNewAccessWorkingFolder(
      Number(idCustomer),
      Number(idWorkingFolder),
      data
    )
      .then(() => {
        setUpdateWorkingFolder(!updateWorkingFolder);
        showToastSuccess("L'accès a été envoyé avec succès");
      })
      .catch(() => {
        showToastError("Une erreur s'est produite. Veuillez réessayer.");
      });
  };

  const handleCheckboxChangeCollabs = (value: number, checked: boolean) => {
    if (!checked) {
      const data = {
        idsUsers: [value],
      };
      userUnassignToWorkingFolder(
        Number(idCustomer),
        Number(idWorkingFolder),
        data
      )
        .then(() => {
          setUpdateWorkingFolder(!updateWorkingFolder);
          showToastSuccess("L'utilisateur a été retiré avec succès");
        })
        .catch(() => {
          showToastError("Une erreur s'est produite. Veuillez réessayer.");
        });
    } else {
      const data = {
        idsUsers: [value],
      };
      userAssignToWorkingFolder(
        Number(idCustomer),
        Number(idWorkingFolder),
        data
      )
        .then(() => {
          setUpdateWorkingFolder(!updateWorkingFolder);
          showToastSuccess("L'utilisateur a été ajouté avec succès");
        })
        .catch(() => {
          showToastError("Une erreur s'est produite. Veuillez réessayer.");
        });
    }
  };

  return (
    <div className="w-full h-full flex flex-col gap-4 lg:gap-6 ">
      {/* Table des utilisateurs avec accès */}
      <div className="w-full bg-white rounded-lg border border-gray-200 flex-1 flex flex-col min-h-0">
        <div className="px-4 2xl:py-3 py-2 bg-gray-50 border-b border-gray-200 flex-shrink-0">
          <h4 className="font-semibold text-gray-700">{t("partner.usersWithAccess")}</h4>
        </div>
        <div className="flex-1 overflow-auto min-h-0">
          <table className="w-full min-w-[600px] sm:min-w-[700px] md:min-w-[800px]">
            <thead className="bg-gray-50 sticky top-0 z-10">
              <tr>
                <th className="px-2 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[150px] sm:min-w-[200px]">
                  {t("partner.user")}
                </th>
                <th className="px-2 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[120px] sm:min-w-[150px]">
                  {t("partner.sendDate")}
                </th>
                <th className="px-2 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[100px] sm:min-w-[120px]">
                  {t("partner.downloaded")}
                </th>
                <th className="px-2 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[120px] sm:min-w-[150px]">
                  {t("partner.downloadDate")}
                </th>
                <th className="px-2 sm:px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[100px] sm:min-w-[120px]">
                  {t("common.actions")}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {workingFolderDetails?.workingFolder?.accessUsers?.map(
                (user: any) => (
                  <tr key={user.id} className="hover:bg-gray-50">
                    <td className="px-2 sm:px-4 py-3 text-sm text-gray-900">
                      <div className="truncate max-w-[120px] sm:max-w-[180px]" title={user.email}>
                        {user.email}
                      </div>
                    </td>
                    <td className="px-2 sm:px-4 py-3 text-sm text-gray-600">
                      {formatDate(user.sendDate)}
                    </td>
                    <td className="px-2 sm:px-4 py-3 text-sm">
                      {user.dateDownload !== null ? (
                        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                          ✅ {t("common.yes")}
                        </span>
                      ) : (
                        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                          ❌ {t("common.no")}
                        </span>
                      )}
                    </td>
                    <td className="px-2 sm:px-4 py-3 text-sm text-gray-600">
                      {user.dateDownload !== null
                        ? dateFormat(user.dateDownload)
                        : "-"}
                    </td>
                    <td className="px-2 sm:px-4 py-3 text-sm font-medium text-center">
                      <div className="flex items-center justify-center gap-1 sm:gap-2">
                        <button 
                          onClick={() => handleSendAccess(user.email)}
                          className="p-1 sm:p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors duration-200"
                          title={t("partner.resendAccess")}
                        >
                          <img src={send} alt="envoyer" className="w-3 h-3 sm:w-4 sm:h-4" />
                        </button>
                        <button 
                          onClick={() => handleRevokeAccess(user.email)}
                          className="p-1 sm:p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded-lg transition-colors duration-200"
                          title={t("partner.revokeAccess")}
                        >
                          <img src={trash} alt="révoquer" className="w-3 h-3 sm:w-4 sm:h-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Table des collaborateurs assignés */}
      <div className="w-full bg-white rounded-lg border border-gray-200 flex-1 flex flex-col min-h-0 2xl:mb-10 mb-20">
        <div className="px-4 2xl:py-3 py-2 bg-gray-50 border-b border-gray-200 flex-shrink-0">
          <h4 className="font-semibold text-gray-700">{t("partner.availableCollabs")}</h4>
        </div>
        <div className="flex-1 overflow-auto min-h-0">
          <table className="w-full min-w-[500px] sm:min-w-[600px]">
            <thead className="bg-gray-50 sticky top-0 z-10">
              <tr>
                <th className="px-2 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[100px] sm:min-w-[120px]">
                  {t("partner.firstName")}
                </th>
                <th className="px-2 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[100px] sm:min-w-[120px]">
                  {t("partner.lastName")}
                </th>
                <th className="px-2 sm:px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[150px] sm:min-w-[200px]">
                  {t("partner.email")}
                </th>
                <th className="px-2 sm:px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[100px] sm:min-w-[120px]">
                  {t("partner.assignment")}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {collabsAssignedToClient?.map((user: any) => (
                <tr key={user.idUser} className="hover:bg-gray-50">
                  <td className="px-2 sm:px-4 py-3 text-sm text-gray-900">
                    <div className="truncate max-w-[80px] sm:max-w-[100px]" title={user.firstName}>
                      {user.firstName}
                    </div>
                  </td>
                  <td className="px-2 sm:px-4 py-3 text-sm text-gray-900">
                    <div className="truncate max-w-[80px] sm:max-w-[100px]" title={user.lastName}>
                      {user.lastName}
                    </div>
                  </td>
                  <td className="px-2 sm:px-4 py-3 text-sm text-gray-600">
                    <div className="truncate max-w-[120px] sm:max-w-[180px]" title={user.eMail}>
                      {user.eMail}
                    </div>
                  </td>
                  <td className="px-2 sm:px-4 py-3 text-sm font-medium text-center">
                    <input
                      type="checkbox"
                      checked={checkboxValuesCollabs[user?.id] || false}
                      onChange={() => {
                        handleCheckboxChangeCollabs(
                          user?.id,
                          !checkboxValuesCollabs[user?.id]
                        );
                      }}
                      className="w-3 h-3 sm:w-4 sm:h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UsersAffectedWorkingFolder;
